import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import showFurnitureImg from '../../assets/images/ribbons/cabinetRibbon/showFurniture.svg';
import { useTranslation } from 'react-i18next';
import { displayFurniture } from 'containers/Configurator/actions/furniture';
import { createStructuredSelector } from 'reselect';
import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';
import { RootState } from 'containers/UserActions/types';
import reducer from './reducer';
import saga from './saga';
import AddToCart from 'containers/UserActions/AddToCart';
import { FurnitureEditorContext } from 'lib/constraintsChecker/FurnitureEditor';
import { makeSelectContext } from 'containers/Configurator/selectors/general';
import { displayTutorialAction } from 'containers/TutorialTour/actions';
import Img from '../../components/Img';
import { Printer } from '../Printer';
import { FiHelpCircle } from 'react-icons/fi';
import { FaRegShareSquare } from 'react-icons/fa';
import PrintTrigger from '../Printer/PrintTrigger';
import properties from '../../helpers/config';
import AddToCurrentOrder from './AddToCurrentOrder';
import { exportCollada } from '../Viewer';
import ExportFurniture from './Export';
import {
  makeSelectIsSubmittingFurniture,
  makeSelectSaveModeFurniture,
} from './selectors';
import { CircleSpinner } from 'react-spinners-kit';
import { SaveMode } from './constants';

interface StateProps {
  context: FurnitureEditorContext;
  saveMode?: SaveMode;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  context: makeSelectContext(),
  saveMode: makeSelectSaveModeFurniture(),
});

const key = 'userActions';
function UserActions({ isCabinetInFurniture = false }) {
  useInjectReducer({ key: key, reducer: reducer });
  useInjectSaga({ key: key, saga: saga });
  const { t } = useTranslation();
  const { context, saveMode } = useSelector(stateSelector);

  const dispatch = useDispatch();

  function showFurniture() {
    dispatch(displayFurniture());
  }

  function startTutorial() {
    dispatch(displayTutorialAction(true));
  }

  return (
    <div className="w-full flex flex-col">
      {saveMode !== undefined && (
        <div className="w-full h-32 flex justify-center">
          <div className="flex items-center justify-center">
            <CircleSpinner size={50} color="#2d3748" />
          </div>
        </div>
      )}
      {isCabinetInFurniture ? (
        <div style={{ display: saveMode !== undefined ? 'none' : 'block' }}>
          <div className="flex flex-col w-80">
            <button
              onClick={showFurniture}
              className="bg-white text-gray-800 border border-gray-400 px-0 py-0 text-2xl my-2 flex items-center justify-center"
            >
              <Img src={showFurnitureImg} alt={'show'} className="h-16 w-16" />
              <span className="ml-4">{t('See my furniture')}</span>
            </button>
          </div>
        </div>
      ) : (
        <div style={{ display: saveMode !== undefined ? 'none' : 'block' }}>
          <div className="flex flex-col w-80 tuto-step-save">
            {properties.editInOrder && properties.addToCurrentOrderCallback ? (
              <AddToCurrentOrder />
            ) : null}
            <AddToCart />
          </div>
          <div className="flex justify-center mt-4 mb-2">
            <Printer />
            <PrintTrigger />
            <ExportFurniture />
          </div>
          <div className="flex w-full justify-center items-center mt-4 mb-4">
            <FiHelpCircle className="h-5 w-5" />
            <a onClick={startTutorial} className="ml-2 cursor-pointer">
              {t('Discover the configurator')}
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserActions;
